import { c as _c } from "react/compiler-runtime";
import useEmblaCarousel from 'embla-carousel-react';
import { NextButton, PrevButton, useCarouselArrows } from '@/features/listing/components/listing-card/listing-carousel-arrows/use-carousel-arrows';
import ReviewCard from '@/features/reviews/components/review-card/review-card';
import { type Review } from '@/features/reviews/types/reviews-types';
import styles from './reviews-carousel.module.scss';
interface ReviewsCarouselProps {
  reviews: Review[];
}
export default function ReviewsCarousel(props) {
  const $ = _c(20);
  const {
    reviews
  } = props;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      align: "start"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(t0);
  const {
    nextBtnDisabled,
    onNextButtonClick,
    onPrevButtonClick,
    prevBtnDisabled
  } = useCarouselArrows(emblaApi);
  let t1;
  if ($[1] !== reviews) {
    t1 = reviews.map(_temp);
    $[1] = reviews;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className={styles.embla__container}>{t1}</div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== emblaRef || $[6] !== t2) {
    t3 = <div className={styles.embla__viewport} ref={emblaRef}>{t2}</div>;
    $[5] = emblaRef;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== onPrevButtonClick || $[9] !== prevBtnDisabled) {
    t4 = <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} isListingDetailPreview={true} shade="dark" />;
    $[8] = onPrevButtonClick;
    $[9] = prevBtnDisabled;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== nextBtnDisabled || $[12] !== onNextButtonClick) {
    t5 = <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} isListingDetailPreview={true} shade="dark" />;
    $[11] = nextBtnDisabled;
    $[12] = onNextButtonClick;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t4 || $[15] !== t5) {
    t6 = <div className={styles.embla__buttons}>{t4}{t5}</div>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t3 || $[18] !== t6) {
    t7 = <section className={styles.embla}>{t3}{t6}</section>;
    $[17] = t3;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}
function _temp(review) {
  return <div key={review.id} className={styles.embla__slide}><ReviewCard review={review} /></div>;
}